import { agentDomain } from '@/environment';
import { useAgentIsV2 } from '@/pages/avatar/hooks/useAgentIsV2';
import theme from '@/theme';
import { IAgent, IAgentKey } from '@d-id/types';
import styled from '@emotion/styled';
import { CopyButton } from './CopyButton';

interface Props {
    agent?: IAgent;
    clientKey?: IAgentKey;
    domains: string[];
    isCopied?: boolean;
}

const CodeSection = styled('div')<{ visible: boolean }>`
    display: ${props => (props.visible ? 'block' : 'none')};
    padding: 20px;
    margin-top: 16px;
    position: relative;
    width: 100%;
    border-radius: 8px;
    background-color: ${theme.colors.settings};
    overflow-x: hidden;
`;

const StyledCode = styled('code')`
    color: ${theme.colors.secondary.main};
    font-size: 14px;
    font-family: Mulish, sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    word-wrap: normal;
    text-align: left;
    display: block;
`;

const StyledPre = styled('div')`
    overflow: auto;
    word-wrap: break-word;
    white-space: pre;
    max-width: 100%;
`;

export const AgentShareEmbedCode = ({ agent, clientKey, domains, isCopied }: Props) => {
    const isV2 = useAgentIsV2(agent?.id);

    return (
        <CodeSection visible={domains.length > 0}>
            <StyledPre>
                <StyledCode>{generateSampleCode(isV2, agent?.id, clientKey?.client_key).trim()}</StyledCode>
                <CopyButton text={generateSampleCode(isV2, agent?.id, clientKey?.client_key)} type="code" isCopied={isCopied}></CopyButton>
            </StyledPre>
        </CodeSection>
    );
};

const generateSampleCode = (isV2: boolean, agentId?: string, clientKey?: string) => {
    const version = isV2 ? 'v2' : 'v1';

    return `
<script
    type="module"
    src="${agentDomain}/${version}/index.js"
    data-name="did-agent"
    data-mode="fabio"
    data-client-key="${clientKey}"
    data-agent-id="${agentId}"
    data-monitor="true"
</script>
    `;
};
